// 导入用来创建路由和确定路由模式的两个方法
import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        // 根据设备类型跳转：手机访问进移动端登录，PC 访问进 PC 端登录
        redirect: () => {
            const ua = navigator.userAgent.toLowerCase();
            const isMobile = /mobile|android|iphone|ipad|ipod|harmonyos/i.test(ua);
            return isMobile ? '/mobileLogin' : '/login';
        },
        component: () => import('@/views/login'),
        meta: {
            keepAlive: false,
            title: '审友问卷-登录'
        }
    },
    {
        name: 'index',
        path: '/index',
        component: () => import('@/views/index'),
        meta: {
            keepAlive: false,
            title: '审友问卷-首页'
        }
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('@/views/login'),
        meta: {
            keepAlive: false,
            title: '审友问卷-登录'
        }
    },
    {
        name: 'project',
        path: '/project',
        component: () => import('@/views/home/project'),
        meta: {
            keepAlive: false,
            title: '审友问卷-项目管理'
        }
    },
    {
        name: 'questionnaire',
        path: '/questionnaire',
        component: () => import('@/views/home/questionnaire'),
        meta: {
            keepAlive: false,
            title: '审友问卷-问卷管理'
        }
    },
    {
        name: 'question',
        path: '/question',
        component: () => import('@/views/home/question'),
        meta: {
            keepAlive: false,
            title: '审友问卷-题目管理'
        }
    },
    {
        name: 'answer',
        path: '/answer',
        component: () => import('@/views/home/answer'),
        meta: {
            keepAlive: false,
            title: '审友问卷-问卷填写'
        }
    },
    {
        name: 'user',
        path: '/user',
        component: () => import('@/views/home/user'),
        meta: {
            keepAlive: false,
            title: '审友问卷-用户管理'
        }
    },
    {
        name: 'answerList',
        path: '/answerList',
        component: () => import('@/views/home/answerList'),
        meta: {
            keepAlive: false,
            title: '审友问卷-答卷列表'
        }
    },
    {
        name: 'statistics',
        path: '/statistics',
        component: () => import('@/views/home/statistics'),
        meta: {
            keepAlive: false,
            title: '审友问卷-答卷统计'
        }
    },
    {
        name: 'questionBank',
        path: '/questionBank',
        component: () => import('@/views/home/questionBank'),
        meta: {
            keepAlive: false,
            title: '审友问卷-题库管理'
        }
    },
    {
        name: 'register',
        path: '/register',
        component: () => import('@/views/register'),
        meta: {
            keepAlive: false,
            title: '审友问卷-注册'
        }
    },
    {
        name: 'updatePwd',
        path: '/updatePwd',
        component: () => import('@/views/updatePwd'),
        meta: {
            keepAlive: false,
            title: '审友问卷-修改密码'
        }
    },
    {
        name: 'mobileAnswer',
        path: '/mobileAnswer',
        component: () => import('@/views/mobile/home/answer.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-问卷填写'
        }
    },
    {
        name: 'mobileLogin',
        path: '/mobileLogin',
        component: () => import('@/views/mobile/login/index.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端登录'
        }
    },
    {
        name: 'mobileRegister',
        path: '/mobileRegister',
        component: () => import('@/views/mobile/register/index.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端注册'
        }
    },
    {
        name: 'mobileUpdatePwd',
        path: '/mobileUpdatePwd',
        component: () => import('@/views/mobile/updatePwd/index.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端修改密码'
        }
    },
    {
        name: 'mobileHome',
        path: '/mobileHome',
        component: () => import('@/views/mobile/home/project.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端项目管理'
        }
    },
    {
        name: 'mobileQuestionnaire',
        path: '/mobileQuestionnaire',
        component: () => import('@/views/mobile/home/questionnaire.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端问卷管理'
        }
    },
    {
        name: 'mobileQuestion',
        path: '/mobileQuestion',
        component: () => import('@/views/mobile/home/question.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端问卷设计'
        }
    },
    {
        name: 'mobileAnswerList',
        path: '/mobileAnswerList',
        component: () => import('@/views/mobile/home/answerList.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端答卷列表'
        }
    },
    {
        name: 'mobileStatistics',
        path: '/mobileStatistics',
        component: () => import('@/views/mobile/home/statistics.vue'),
        meta: {
            keepAlive: false,
            title: '审友问卷-移动端答卷统计'
        }
    }
]

// 创建路由实例并传递 `routes` 配置
// 我们在这里使用 html5 的路由模式，url中不带有#，部署项目的时候需要注意。
const router = createRouter({
    history: createWebHashHistory(),
    base: 'wjxbx',
    routes,
})

// 需要登录才能访问的 PC 端管理页面
const authRequiredPages = [
    '/project',
    '/questionnaire',
    '/question',
    '/answerList',
    '/statistics',
    '/questionBank',
    '/user'
]

// 登录守卫：未登录直接访问管理页时，跳回登录页
router.beforeEach((to, from, next) => {
    if (authRequiredPages.includes(to.path) && !sessionStorage.getItem('token')) {
        next({path: '/login'})
    } else {
        next()
    }
})

// 讲路由实例导出
export default router